import "../extensions/form";
import { Validation } from "../modules/validation/validation";
import { AjaxRequest, AjaxMethod, AjaxResponseType } from "../modules/ajax";
export default class Forms {
    constructor() {
        this.elements = document.querySelectorAll(".ajax-form");
        if (this.elements != null) {
            this.init();
        }
    }
    init() {
        this.elements.forEach((form) => {
            let validator = new Validation(form, []);
            validator.onSubmit = (f) => { this.onSubmit(f); };
        });
        let uploads = document.querySelectorAll("input[type='file']");
        uploads.forEach((upload) => {
            if (upload.nextElementSibling instanceof HTMLLabelElement) {
                this.customUploads(upload, upload.nextElementSibling);
            }
        });
    }
    customUploads(upload, label) {
        label.setAttribute("data-default", label.innerText);
        upload.addEventListener("change", (e) => {
            let input = e.currentTarget;
            if (input.files.length > 0) {
                if (input.files.length == 1) {
                    label.innerText = input.files[0].name;
                }
                else {
                    label.innerText = "(" + input.files.length + ")";
                }
            }
            else {
                label.innerText = label.getAttribute("data-default");
            }
        });
    }
    onSubmit(form) {
        let url = form.getAttribute("action");
        let method = form.getAttribute("method") != null ? form.getAttribute("method") : AjaxMethod.GET;
        //let requestType: string = form.getAttribute("enctype") != null ? form.getAttribute("enctype") : AjaxRequestType.FORM;
        let ajax = new AjaxRequest();
        let options = { ResponseType: AjaxResponseType.JSON }; //{ RequestType: requestType, ResponseType: AjaxResponseType.JSON };
        let data = new FormData(form);
        console.log(data);
        var button = form.querySelector("button[type='submit']");
        if (button) {
            button.classList.add("loading");
            button.disabled = true;
        }
        ajax.Send(method, url, data, options).then(results => {
            this.setAlert(form, results.data.Success, results.data.Message);
            if (button) {
                button.classList.remove("loading");
                button.disabled = false;
            }
        }, error => {
            var message = "Error something went wrong";
            if (error instanceof String) {
                message = error;
            }
            else if (error.data?.Message instanceof String) {
                this.setAlert(form, false, error.data.Message);
            }
            this.setAlert(form, false, message);
            if (button) {
                button.classList.remove("loading");
                button.disabled = false;
            }
        });
    }
    setAlert(form, success, message) {
        let alert = form.querySelector(".alert");
        if (alert == null) {
            alert = document.createElement("div");
            form.appendChild(alert);
        }
        alert.addClass("alert");
        if (success) {
            alert.addClass("alert-success");
            alert.removeClass("alert-danger");
        }
        else {
            alert.addClass("alert-danger");
            alert.removeClass("alert-success");
        }
        alert.innerHTML = "<p class='mb-0'>" + message + "</p>";
    }
}
